<template>
  <ul class="menu">
    <m4-menu-item v-for="(item, index) in items" :key="index" :item="item"></m4-menu-item>
  </ul>
</template>

<script>
import M4MenuItem from "./menu-item.vue";

export default {
  name: "M4Menu",
  components: { M4MenuItem },
  props: {
    items: Array
  },
  methods: {}
};
</script>

<style scoped></style>
